exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-email-stack[data-v-1d1fdc14]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;gap:14px}.verify-email-change-trigger[data-v-1d1fdc14]{-ms-flex-item-align:center;align-self:center;padding-top:0}.sb-next[data-v-1d1fdc14]{width:100%;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
